import * as React from 'react';
import { useEffect, useState } from "react";
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Select from 'antd/lib/select';
import Modal from 'antd/lib/modal';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import Popconfirm from 'antd/lib/popconfirm';
import Form from 'antd/lib/form';
import TextArea from 'antd/lib/input/TextArea';
import Collapse from 'antd/lib/collapse';
import { ContactsFilled } from '@ant-design/icons';

const { Panel } = Collapse;

import {
    useDispatch,
    useSelector,
  } from 'react-redux';
import {
    Card
  } from 'one-ui-card/src/card';

const {
    Option,
} = Select;

export const CallRecord = ()=> {
   
    const dispatch = useDispatch();
    const [number, setNumber] = useState("");
    const [openedby, setOpenedBy] = useState("");
    const [opened, setOpened] = useState("");
    const [subject, setSubject] = useState("");
    const [incidentcategory, setIncidentCategory] = useState("");
    const [incidentstatus, setIncidentStatus] = useState("");
    const [incidentsubject, setIncidentSubject] = useState("");
    const [incidentdescription, setIncidentDescription] = useState("");
    const [openedincidentat, setOpenedIncidentAt] = useState("")
    const [ismodalvisible,setIsModalVisible] = useState(false)
    const [ispopvisible, setIsPopVisible] = useState(false);
    const [description, setDescription] = useState("");
    const [incidentnumber,setIncidentNumber] = useState("");
    const [statusvalue,setStatusValue] = useState("")
    const [emailid,setEmailId] = useState("");
    const servicenowinfo = useSelector((state:any) => (state.servicenowcaller));
    const incidentsinfo = useSelector((state:any)=> (state.getincidents));
    const createinteractionsdata = useSelector((state:any)=> (state.createinteraction));
    const createincidentsdata = useSelector((state:any)=> (state.createincident));
    const linkedincidentdata = useSelector((state:any)=> (state.linkedincident))
    const [category,setCategory] = useState([]);
    const [status,setStatus] =  useState([]);
    const [linkedincidentoptions,setLinkedIncidentOptions] = useState([]);

    let tagoption:any = [];
    let name ="";
    const states = [{
      value: '1',
      label: 'New',
    }, {
      value: '2',
      label: 'In Progress',
    }, {
      value: '3',
      label: 'On Hold',
    }, {
      value: '6',
      label: 'Resolved',
    }, {
      value: '7',
      label: 'Closed',
    }, {
      value: '8',
      label: 'Cancelled',
    }]

    useEffect(() => {

      if (servicenowinfo) {
        name = servicenowinfo?.selected?.name;
        let email = servicenowinfo?.selected?.email
        setOpenedBy(name);
        setEmailId(email);
      }
    }, [servicenowinfo]);

    useEffect(() => {
      if (incidentsinfo?.callerincidentdata && incidentsinfo?.callerincidentdata?.length > 0) {
        let categoryarray:any = [],statusarray:any=[];
        incidentsinfo.callerincidentdata.forEach((categorydata:any)=> {
          if(categorydata?.category && (!categoryarray.includes(categorydata?.category))) {
            categoryarray.push(categorydata?.category)
          }
          if(categorydata?.state && (!statusarray.includes(categorydata.state))) {
            statusarray.push(categorydata.state)
          }
        })
        setCategory(categoryarray);
        setStatus(statusarray);
      }
    }, [incidentsinfo]);

    useEffect(() => {
      if (createinteractionsdata?.output?.results?.length > 0) {
          createinteractionsdata.output.results.map((interactioninfo:any)=> {
          setNumber(interactioninfo.result.number);
          setOpened(interactioninfo.result.sys_created_on)
        })
      }
    }, [createinteractionsdata]);

    useEffect(() => {
      if(createincidentsdata?.output?.results?.length > 0) {
        createincidentsdata.output.results.forEach((incidentinfo:any)=> {
          setIncidentNumber(incidentinfo.number)
          setOpenedIncidentAt(incidentsinfo.sys_created_on)
        })
      }
    },[createincidentsdata])

    useEffect(() => {
      if (linkedincidentdata?.output?.results?.length >0) {
        linkedincidentdata.output.results.forEach((linkeddata:any)=>{
          if(linkeddata?.result?.global_task) {
            let incidentoptions = linkeddata.result.global_task;
            setLinkedIncidentOptions(incidentoptions)
            setDefaultLinked(linkeddata.result.global_task);
            tagoption = linkeddata.result.global_task;
          }
        })
      }
    }, [linkedincidentdata]);
    function handleChange(value:any) {
      console.log(`selected ${value}`,linkedincidentoptions);
    }

    const handleSubjectchange = (event: any) => {
      setSubject(event.target.value)
    }

    const handleDescriptionchange = (event:any) =>{
      setDescription(event.target.value)
    }

    const handleStatusChange = (event:any) =>{
      setIncidentStatus(event)
      let statusnumber = "";
      if(states) {
        states.forEach((stateinfo:any)=> {
          if(stateinfo.label === event) {
            statusnumber = stateinfo.value;
          }
        })
        setStatusValue(statusnumber)
      }
    }


    const handleSave = () =>{
      let email = servicenowinfo?.selected?.email
      dispatch({
        type: "one-state-createinteractions/fetch",
        payload: {
          description: description,
          opened_for: name,
          short_description: subject,
        }
      });
      dispatch({
        type: "one-state-interactions/fetch",
        payload: {
          email: email
        }
      });
    }

  const onOk = () => {

    dispatch({
      type: "one-state-createincidents/fetch",
      payload: {
        caller_id: emailid,
        category: incidentcategory,
        description: incidentdescription,
        short_description: incidentsubject,
        state: statusvalue,
      }
    });
    dispatch({
      type:"one-state-linkincidents/fetch",
      payload: {
        interaction: number,
        task: incidentnumber
      }
    });
    dispatch({
      type: "one-state-incidents/fetch",
      payload: {
        email: emailid
      }
    });
    setIsModalVisible(false);
  };


  const onCancel = () => {
    setIncidentCategory("");
    setIncidentDescription("");
    setIncidentNumber("");
    setIncidentStatus("");
    setIncidentSubject("");
    setIsModalVisible(false)
 }

  const handleOk = () => {
    setSubject("");
    setDescription("");
    setIsPopVisible(false);
  }

  const handleRecordCancel = () => {
    setIsPopVisible(true);
  }

  const handlePopCancel = () => {
    setIsPopVisible(false);
  }

 const handleClick = (event: any) => {
    setIsModalVisible(true)
  }
  const handleCategoryChange = (event: any) => {
    setIncidentCategory(event)
  }

  const handleIncidentSubject = (event:any) => {
    setIncidentSubject(event.target.value);
  }

  const handleIncidentDescription = (event:any) => {
    setIncidentDescription(event.target.value);
  }

    const generalform = (
        <div>
            <h2>Call Record</h2>
        <Form>
          <Row gutter={8} align="middle">
            <Col span={8}>
              <text>Number</text>
              <Form.Item>
                <Input name="number" placeholder="Number" value={number} disabled />
              </Form.Item>
            </Col>
            <Col span={8}>
              <text>Opened by</text>
              <Form.Item>
                <Input
                  name="openedBy"
                  placeholder="Opened By"
                  disabled
                  value={openedby}
                  
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <text>Opened</text>
              <Form.Item>
                <Input name="opened" placeholder="Opened" disabled value={opened} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <text>Subject</text>
              <Form.Item>
                <Input
                  name="subject"
                  placeholder="Subject"
                  value={subject}
                  onChange={(e) =>handleSubjectchange(e)}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <text>Linked Incidents</text>
              <Form.Item>
                <Select mode="multiple" style={{ width: '100%' }} placeholder="Linked Incidents" onChange={handleChange} defaultValue={tagoption}>
                {
                          linkedincidentoptions ? linkedincidentoptions.map((linkincidentoption: any, index: number) => (
                            <Option value={linkincidentoption} key={index}>{linkincidentoption}</Option>
                          )) : ""
                }
                </Select>
              </Form.Item>

            </Col>
            <Col span={24}>
              <text>Description</text>
              <Form.Item>
                <TextArea
                  name="description"
                  placeholder="Description"
                  value={description}
                  onChange={(e) =>handleDescriptionchange(e)}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Row type="flex" justify="space-between" gutter={[16, 16]} style={{ width: '100%' }}>
          <Col>
             <Button
             type="link"
             style={{
               border: '1px solid #e84a13',
             }}
             onClick={handleClick}
             disabled={!number}
           >
             New Incident
           </Button>
          </Col>
          <Col>
            <Row type="flex" gutter={[16, 0]}>
              <Col>
              <Popconfirm
                  title="Are you sure"
                  visible={ispopvisible}
                  onConfirm={handleOk}
                  onCancel={handlePopCancel}
                >
                <Button type="ghost" onClick={handleRecordCancel}>Cancel</Button>
                </Popconfirm>
              </Col>
              <Col>
                {number && (
                  <Button
                    type="link"
                    style={{
                      border: '1px solid #19a800',
                    }}
                    className={`btn-save ${!!number ? 'inactive' : ''}`}
                    disabled
                  >
                    Saved
                  </Button>
                )}
                
                 {!number && (
                   <Button
                   type="link"
                   style={{
                     border: '1px solid #e84a13',
                   }}
                   disabled={(!subject || subject === '') && (!description || description === '')}
                   onClick={handleSave}
                   
                 >
                   Save
                 </Button>
                 )} 
              </Col>
            </Row>
          </Col>
        </Row>
        <Modal
          title={"New Incident"}
          visible={ismodalvisible}
          centered
          destroyOnClose
          onCancel={onCancel}
          onOk={onOk}
          okButtonProps={{ form: 'new-call-modal', htmlType: 'submit' }}
          okText={"Create & Link to the Call"}
          wrapClassName="custom-modal-wrap"
          width={650}
        >
          {createincidentsdata && (
            <div className="flex justify-end mb-5">
              <a
                href={`https://dev117142.service-now.com/nav_to.do?uri=incident.do?sys_id=${createincidentsdata.sys_id}`}
                target="_blank"
                className="open-servicenow-button"
              >
                Show in ServiceNow
              </a>

            </div>
          )}
          <Form id="new-call-modal">
            <Collapse defaultActiveKey={['1', '2']} className="ant-no-border-panel-collapse">
              <Panel header="Call Information" showArrow={false} key="1">
                <Row gutter={[16, 16]}>
                  <Col md={12} span={24}>
                    <text>Caller</text>
                    <Form.Item>
                      <Input name="caller_id" value={openedby} placeholder="Caller" prefix={<ContactsFilled />} readOnly />
                    </Form.Item>
                  </Col>
                  <Col md={12} span={24}>
                    <text>Opened</text>
                    <Form.Item>
                      <Input name="opened_at" value={openedincidentat} disabled={!openedincidentat} readOnly />
                    </Form.Item>
                  </Col>
                  <Col md={12} span={24}>
                    <text>Opened by</text>
                    <Form.Item>
                      <Input name="opened_by" value={openedby} placeholder="Opened by" readOnly />
                    </Form.Item>
                  </Col>
                  <Col md={12} span={24}>
                    <text>Category</text>
                    <Form.Item>
                      <Select placeholder="Category" value={incidentcategory} onChange={handleCategoryChange}>
                        {
                          category ? category.map((categoryoption: any, index: number) => (
                            <Option value={categoryoption} key={index}>{categoryoption}</Option>
                          )) : ""
                        }
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col md={12} span={24}>
                    <text>State</text>
                    <Form.Item>
                      <Select placeholder="State" value={incidentstatus} onChange={handleStatusChange}>
                        {
                          status ? status.map((statusoption: any, index: number) => (
                            <Option value={statusoption} key={index}>{statusoption}</Option>
                          )) : ""
                        }
                      </Select>
                    </Form.Item>
                  </Col>

                </Row>
              </Panel>
              <Panel header="Description" showArrow={false} key="2">
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <text>Subject</text>
                    <Form.Item>
                      <Input name="short_description" value={incidentsubject} placeholder="Subject" onChange={handleIncidentSubject} />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <text>Description</text>
                    <Form.Item>
                      <TextArea name="description" value={incidentdescription} placeholder="Description" onChange={handleIncidentDescription} />
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>
            </Collapse>
          </Form>
        </Modal>
        
        </div>
    );

    return (
        <Card
        title=''
        body={generalform}
        />
    );
}